<template>
	<div class="home">
		<router-view />
	</div>
</template>
<script>
// @ is an alias to /src
import '@/css/version.scss';
export default {
	name: 'Layout',
	components: {}
};
</script>
